/**
 * @module PerspectivePreview
 * @return {Object} public methods
 */

const PerspectivePreview = (function () {
    var width = 330;
    var margin = 60;

    function init() {
        if (document.getElementById('perspective-preview') === null) return false;

        handleResponsive();

        window.my360degree = new GAniFw.instance('window.my360degree', width, width, 40, 'perspective-preview__image', false, 'https://www.reiner-sct.com/img/GAniFw_overlay.png');
        window.changePerspective = onWindowChangePerspective;

        window.addEventListener('resize', onWindowResize, false);

        // Slick prevents the control of 3d preview so we stop the slick events on the 3d preview slider/range input
        $('.perspective-preview__control').on('touchmove.slick mousemove.slick', function(e){
            e.stopPropagation();
        });
    }

    function onWindowResize() {
        handleResponsive();
    }

    function onWindowChangePerspective(value) {
        var wrapper;

        window.my360degree.engine.stop();

        document.getElementById('perspective-preview__image').style.left = "-" + value + "px";

        // remove mouse info
        wrapper = document.getElementById('perspective-preview__imageWrapper');

        if (wrapper.children.length >= 3) {
            wrapper.children[2].remove();
        }
    }

    function handleResponsive() {
        if (!matchMedia('only screen and (min-width: 564px)').matches) {
            width = Math.floor(document.documentElement.clientWidth - margin);

            if (width > 300) width = 300;

            $('#perspective-preview__imageWrapper').css('width', width);
            $('#perspective-preview__imageWrapper').css('height', width);
            $('.perspective-preview__control > input').attr('step', width);
            $('.perspective-preview__control > input').attr('max', $('#perspective-preview__imageWrapper > img').data('images-count') * width);
        }
    }

    // Return public methods
    return {
        init: init
    };
})();

window.PerspectivePreview = PerspectivePreview;
export default PerspectivePreview;
